module.exports = __webpack_public_path__ + "static/img/3.f2ccc6e7.jpg";